$(document).ready(function() {
	if(!document.querySelector('.C0051')) return false;
	
	var $obj = $('.C0051');
	$obj.each(function() {
		var $slick = $(this).find('.items-group .items').slick({
			infinite: false,
			listStyle: true, //LGEGMO-5525
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows : true,
			dots: true,
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows : false
				}
			}],
			prevArrow: carouselOptions.bigAnglePrev, // common.js variable
			nextArrow: carouselOptions.bigAngleNext // common.js variable
		});

		setTimeout( function() {
			$('.C0051').find('.items .slick-prev').attr('role', 'Arrow');
			$('.C0051').find('.items .slick-next').attr('role', 'Arrow');
			$('.C0051').find('.items .slick-prev').attr('aria-label', 'Previous Arrow');
			$('.C0051').find('.items .slick-next').attr('aria-label', 'Next Arrow');
		},3000);

		$('.C0051 .slick-track li').attr({
			tabindex: "-1"
		});	//DC-717
	});
});